module.exports = __webpack_public_path__ + "img/打脸.e67ef35a.png";